import React from 'react';
import ComputoriaImageOne from '../../../images/ComputoriaImageOne.png'
import ComputoriaImageTwo from '../../../images/ComputoriaImageTwo.png'
import ComputoriaImageThree from '../../../images/ComputoriaImageThree.png'
import hungryMonsterImageOne from '../../../images/hungryMonsterImageOne.png'
import hungryMonsterImageTwo from '../../../images/hungryMonsterImageTwo.png'
import hungryMonsterImageThree from '../../../images/hungryMonsterImageThree.png'
import CruiseQueenImgOne from '../../../images/CruiseQueenImgOne.png'
import CruiseQueenImgTwo from '../../../images/CruiseQueenImgTwo.png'
import CruiseQueenImgThree from '../../../images/CruiseQueenImgThree.png'
import PlayersManagementarImageOne from '../../../images/PlayersManagementarImageOne.png'
import PlayersManagementarImageTwo from '../../../images/PlayersManagementarImageTwo.png'
import PlayersManagementarImageThree from '../../../images/PlayersManagementarImageThree.png'
import drinkoFarmImageOne from '../../../images/drinkoFarmImageOne.png'
import drinkoFarmImageTwo from '../../../images/drinkoFarmImageTwo.png'
import drinkoFarmImageThree from '../../../images/drinkoFarmImageThree.png'
import { Carousel } from 'react-bootstrap';
import ProjectPageCard from '../ProjectPageCard/ProjectPageCard';

const projectData = [
    {
        title: 'COMPUTORIA',
        duration: 'March 2021 - April 2021',
        description: 'It is a computer servicing website, which serves Data Recovery, Laptop Repair, Operating System (OS) Management, etc.',
        productImgOne: ComputoriaImageOne,
        productImgTwo: ComputoriaImageTwo,
        productImgThree: ComputoriaImageThree,
        featureOne: "Admin can see all order lists of the users and change the order's status by drop-down menu.",
        featureTwo: "Admin can manage services and make a person 'Admin'.",
        featureThree: "Users can order a service and submit a review.",
        featureFour: "The user can see his all orders and order status.",
        languageOne: "React", languageTwo: "HTML5", languageThree: "CSS3", languageFour: "MongoDB", languageFive: "Express.js", languageSix: "", languageSeven: "React Router", languageEight: "Node.js", languageNine: "React Router", languageTen: "React Router",
        github: "https://github.com/FaiyadAhmedSudipto/computoria-client-side-assigment11",
        server: "https://github.com/FaiyadAhmedSudipto/computoria-server-side-assigment11",
        liveSite: "https://computoria-the-last-assignment.web.app/",
        liveSiteAvailable: 'LiveSite',
        githubAvailable: 'Github',
        serverAvailable: 'Server'
    },
    {
        title: 'CRUISE QUEEN',
        duration: 'Feb 2021 - Feb 2021',
        description: 'It is an online ticket booking website, which serves a simple calculating function and books a water journey.',
        productImgOne: CruiseQueenImgOne,
        productImgTwo: CruiseQueenImgTwo,
        productImgThree: CruiseQueenImgThree,
        featureOne: "Customers can book tickets.",
        featureTwo: "Customers can create an account.",
        featureThree: "Customers will be notified after confirming an order.",
        featureFour: "*I am working with it. So, the update will arrive soon.",
        languageOne: "HTML5", languageTwo: "CSS3", languageThree: "Bootstrap", languageFour: "", languageFive: "", languageSix: "", languageSeven: "", languageEight: "", languageNine: "", languageTen: "",
        github: "https://github.com/FaiyadAhmedSudipto/Assignment4",
        server: "",
        liveSite: "https://faiyadahmedsudipto.github.io/Assignment4/",
        liveSiteAvailable: 'LiveSite',
        githubAvailable: 'Github',
        serverAvailable: ''
    },
    {
        title: 'PLAYERS MANAGMENTAR',
        duration: 'March 2021 - March 2021',
        description: 'It is a player purchasing website. Any team can purchase players for their team from here.',
        productImgOne: PlayersManagementarImageOne,
        productImgTwo: PlayersManagementarImageTwo,
        productImgThree: PlayersManagementarImageThree,
        featureOne: "The website provides a list of some cricketers.",
        featureTwo: "A team can purchase players for their team from here.'",
        featureThree: "The team will see the price for their teams.",
        featureFour: "The team can see their all players also.",
        languageOne: "JavaScript", languageTwo: "React", languageThree: "HTML5", languageFour: "CSS3", languageFive: "Bootstrap", languageSix: "", languageSeven: "", languageEight: "", languageNine: "", languageTen: "",
        github: "https://github.com/FaiyadAhmedSudipto/Players-Managmentar-Assignment7",
        server: "",
        liveSite: "https://friendly-lewin-6906e4.netlify.app/",
        liveSiteAvailable: 'LiveSite',
        githubAvailable: 'Github',
        serverAvailable: ''
    },
    {
        title: 'HUNGRY MONSTAR',
        duration: 'Feb 2021 - March 2021',
        description: 'It is an online food and recipe searching website. Find any foods with its recipe.',
        productImgOne: hungryMonsterImageOne,
        productImgTwo: hungryMonsterImageTwo,
        productImgThree: hungryMonsterImageThree,
        featureOne: "Find any kinds of food you like.",
        featureTwo: "Get the recipe for the selected food.",
        featureThree: "Watch a tutorial about the food's recipe.",
        featureFour: "You will be notified if the foods are not available.",
        languageOne: "JavaScript", languageTwo: "React", languageThree: "HTML5", languageFour: "CSS3", languageFive: "Bootstrap", languageSix: "", languageSeven: "", languageEight: "", languageNine: "", languageTen: "",
        github: "https://github.com/FaiyadAhmedSudipto/Assignment5_Hungry-Monster",
        server: "",
        liveSite: "https://faiyadahmedsudipto.github.io/Assignment5_Hungry-Monster/",
        liveSiteAvailable: 'LiveSite',
        githubAvailable: 'Github',
        serverAvailable: ''
    },
    {
        title: 'DRINKO FARM',
        duration: 'March 2021 - March 2021',
        description: 'It is an online drink ordering website for a company called Drinko Farm.',
        productImgOne: drinkoFarmImageOne,
        productImgTwo: drinkoFarmImageTwo,
        productImgThree: drinkoFarmImageThree,
        featureOne: "Visitors can create an account and see their all orders.",
        featureTwo: "Visitors can order any kind of drink from here.",
        featureThree: "Admin can remove any products from this website.",
        featureFour: "Admin can sell all orders and customers list in the admin panel.",
        languageOne: "JavaScript", languageTwo: "React", languageThree: "HTML5", languageFour: "CSS3", languageFive: "Bootstrap", languageSix: "", languageSeven: "", languageEight: "", languageNine: "", languageTen: "",
        github: "https://github.com/FaiyadAhmedSudipto/Drinko-Farm-Client-Assignment10",
        server: "https://github.com/FaiyadAhmedSudipto/Drinko-Farm-Server-Assignment10",
        liveSite: "https://burj-al-arab-after-auth-done.web.app/",
        liveSiteAvailable: 'LiveSite',
        githubAvailable: 'Github',
        serverAvailable: 'Server'
    }
]

// const slicedProject = projectData.slice(0, 3);
// var sliced = Array.prototype.slice.call(projectData, 1);
// var my_object = {
//     0: 'zero',
//     1: 'one',
//     2: 'two',
//     3: 'three',
//     4: 'four'
//    };

//    var sliced = Array.prototype.slice.call(my_object, 4);
//    console.log(sliced);

const ProjectPageInfo = () => {
    return (
        <div>
            <div className="section-header text-center mt-3">
                <h2 className="fw-bold">Al Projects</h2>
                <h5 className='text-secondary'>My All Projects Are Here</h5>
            </div>
            <div>
                {
                     projectData.map(allProjects => <ProjectPageCard allProjects={allProjects} key={allProjects.title}></ProjectPageCard>)
                }
            </div>
        </div>
    );
};

export default ProjectPageInfo;